import { Store } from 'utils';

class RatioStore extends Store {

	getInitialState() {
		return {
			ratio: 1
		}
	}

	onRatioChanged(state, data) {
		state.ratio = data.ratio;
	}

	getRatio() {
		return this.getState().ratio;
	}

}

const store = new RatioStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/ratiostore.js